// extracted by mini-css-extract-plugin
export default {"galleryHeader":"c-j_hZ"};